export class BackWardRule {
    static Clr_Type_ID = 'wf.BackWardRule';

    readonly ClrTypeID: string = BackWardRule.Clr_Type_ID;
    TargetRef: string;
    SelectTargetAble: boolean;
    WaitReturn: boolean;
    DynamicBackWardRuleAble: boolean;
    SelectTargetList:Array<string>;
    ResubmitEffect: ResubmitEffect;
}
export enum ResubmitEffect {

  sequence = 'sequence',

  backToMe = 'backToMe',

  backToCurrentNode = 'backToCurrentNode'
}
